<lib-generic-select-form-control
  ngDefaultControl
  [dataProvider]="dataProvider"
  [labelField]="labelField"
  [valueField]="valueField"
  [placeholder]="placeholder"
  [formControl]="control"
></lib-generic-select-form-control>
